import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ShowWhiskyPage } from '../showWhisky/showWhisky';
import { Events } from 'ionic-angular/util/events';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';
import { WhiskyDB } from '../../data/db';
import { Whisky } from '../../data/whisky';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';

@Component({
  selector: 'page-basket',
  templateUrl: 'basket.html'
})

export class BasketPage {
  showWhiskyPage: any;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {
    this.initializeItems();
    this.showWhiskyPage = ShowWhiskyPage;

    // Update event
    this.events.subscribe("basket:updated", () => {
      console.log("Got basket:updated event");
      // Reapply fiters
      this.getItems();
    });

  }

  items: Whisky[];
  allItems: Whisky[];
  limit: any = 20;

  initializeItems() {
    // Initial list is unfiltered
    this.getItems();
  }

  getItems() {
    // Reset items back to all of the items
    this.allItems = WhiskyDB.basket;
    this.limit = 20;
    this.items = this.allItems.slice(
      0,
      Math.min(this.limit, this.allItems.length)
    );
  }

  doInfinite(event: any) {
    //console.log("doInfinite");
    // Get next chunk from all filtered & sorted items
    let prior = this.limit;
    this.limit = this.limit + 20;
    //console.log("get more items: " + this.limit);
    this.limit = Math.min(this.limit, this.allItems.length);
    let moreItems = this.allItems.slice(prior, this.limit);

    moreItems.forEach(i => {
      this.items.push(i);
    });

    event.complete();
  }


  remove(toRemove: any, slider: any) {
    slider.close();

    let alert = this.alertCtrl.create({
      title: "Remove from shopping list?",
      subTitle: toRemove.name,
      cssClass: "removeAlert",
      buttons: [
        {
          text: "Cancel",
          role: "Cancel",
          handler: () => {
            console.log("Cancel remove");
          }
        },
        {
          text: "Remove",
          cssClass: "remove-button",
          handler: () => {
            // Remove selected items
            console.log("Remove: " + toRemove);
            // Remove is via a filter
            WhiskyDB.basket = WhiskyDB.basket.filter(item => {
              return item.name !== toRemove.name;
            });
            WhiskyDB.db.saveBasket();
            // Update them
            this.events.publish("basket:updated");
          }
        }
      ]
    });
    alert.present();
  }

  getSubhead(item: Whisky)
  {
    if(item.bottler.length > 0)
      return item.bottler + " - " + item.distillery;
    return item.distillery;
  }
  
  select(item)
  {
    let modal = this.modalCtrl.create(this.showWhiskyPage, { Whisky: item });
    modal.present();
  }



}



// WEBPACK FOOTER //
// ./src/pages/basket/basket.ts